import { ITaskResource } from '../entities/task.entities';
import { TLang } from '../entities/ui.entities';
import { ITaskSetting } from '../entities/user.entities';
import { translate } from './lang.helper';

export const getTaskOptions = (
  lang: TLang | undefined,
  customTasks: ITaskSetting[] | null = null,
) => {
  let result = [
    { id: 'GENERAL', value: 'GENERAL', label: 'General' },
    { id: 'SEEDING', value: 'SEEDING', label: 'Seeding' },
    { id: 'ASSESSMENT', value: 'ASSESSMENT', label: 'Assessment' },
    { id: 'MAINTENANCE', value: 'MAINTENANCE', label: 'Maintenance' },
    { id: 'HARVEST', value: 'HARVEST', label: 'Harvest' },
    {
      id: 'INVENTORY_SEED',
      value: 'INVENTORY_SEED',
      label: 'Inventory Management',
    },
    {
      id: 'Stripped to Waste',
      value: 'Stripped to Waste',
      label: 'Stripped to Waste',
    },
    {
      id: 'TAGGING',
      value: 'TAGGING',
      label: 'Line Tagging',
    },
  ].map(x => ({ ...x, label: translate(lang, x.label) }));
  if (customTasks) {
    result.push(
      ...customTasks.map(x => ({ id: x.name, value: x.name, label: x.name })),
    );
  }
  return result;
};

export const isNormalTask = (type: string | null | undefined) => {
  return (
    !type ||
    ![
      'SEEDING',
      'ASSESSMENT',
      'MAINTENANCE',
      'HARVEST',
      'INVENTORY_SEED',
    ].includes(type)
  );
};

export const getTaskAction = (
  customTasks: ITaskSetting[] | null | undefined,
  value: string | null,
): ITaskResource['action'] => {
  if (!value) return null;
  if (
    [
      'SEEDING',
      'ASSESSMENT',
      'MAINTENANCE',
      'HARVEST',
      'INVENTORY_SEED',
      'TAGGING',
    ].includes(value)
  ) {
    return value as ITaskResource['action'];
  }
  const customTask = customTasks?.find(x => x.name === value);
  if (
    customTask &&
    customTask.action &&
    [
      'SEEDING',
      'ASSESSMENT',
      'MAINTENANCE',
      'HARVEST',
      'INVENTORY_SEED',
      'TAGGING',
    ].includes(customTask.action)
  ) {
    return customTask.action as ITaskResource['action'];
  }
  if (value.toLowerCase() === 'stripped to waste') {
    return 'HARVEST';
  }
  return null;
};
